var Popover = {
    $openPopover: null,
    init: function(selector) {
        if (!$(selector).length) {
            return;
        }
        this.$links = $(selector);
        $(document.body).on('click', this.closePopover.bind(this));
        this.$links.on('click', this.openPopover.bind(this));
    },
    killEvent: function(event) {
        event.preventDefault();
        event.stopPropagation();
    },
    openPopover: function(event) {
        if (!$(event.target.hash).length) {
            event.preventDefault();
            return;
        }
        var $target = $(event.target);
        var $popover = $(event.target.hash);
        this.$openPopover = $popover;

        $popover.on('click', this.killEvent);

        $popover.addClass('is-open');

        var targetRect = $target[0].getBoundingClientRect();
        var left = window.innerWidth - targetRect.right >= targetRect.x ?
            $target.position().left :
            $target.position().left + $target.width() - $popover.width();
        var top = window.innerHeight - targetRect.bottom >= targetRect.y ?
            $target.position().top + $target.height() + 8 :
            $target.position().top - $popover.height() - targetRect.height - 14;

        if (window.innerWidth < 450) { left = 24; }

        $popover.css({ left: left + 'px', top: top + 'px' });

        this.killEvent(event);
    },
    closePopover: function(event) {
        if (this.$openPopover) {
            this.$openPopover.off('click');
            this.$openPopover.removeClass('is-open');
            this.$openPopover = null;
        }
    }
};

Popover.init('.js-popover-trigger');

